const FlagFI = props => (
	<svg height="28" viewBox="0 0 200 200" width="28" {...props}>
		<rect fill="#fff" x="2" width="200" height="200" />
		<rect fill="#4758a9" x="-4" y="85" width="208" height="30" transform="translate(200) rotate(90)" />
		<rect fill="#4758a9" x="-4" y="85" width="208" height="30" transform="translate(200 200) rotate(180)" />
	</svg>
);

export default FlagFI;
